/* FAQ „Zwei Spalten, kompakt“: nur die ersten N Fragen zeigen, Rest per Button.
   Mobil wandert die Kontaktkarte unter die Liste. Ausgeblendete Fragen bleiben im DOM. */
(function(){
  function init(root){
    if (root.__mpxSplit) return; root.__mpxSplit = true;
    var n = parseInt(root.getAttribute('data-visible') || '0', 10);
    var main = root.querySelector('.mp-faq__main');
    var items = root.querySelectorAll('.mp-faq__item');
    var ask = root.querySelector('.mp-faq__ask');
    if (n > 0 && items.length > n && main) {
      for (var i = n; i < items.length; i++) items[i].classList.add('is-extra');
      var more = root.getAttribute('data-more-text') || 'Alle Fragen anzeigen';
      var less = root.getAttribute('data-less-text') || 'Weniger anzeigen';
      var btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'mp-faq__more';
      btn.setAttribute('aria-expanded', 'false');
      btn.textContent = more.indexOf('Alle') === 0 ? more.replace('Alle', 'Alle ' + items.length) : more;
      var moreLabel = btn.textContent;
      btn.addEventListener('click', function(){
        var all = root.classList.toggle('is-all');
        btn.setAttribute('aria-expanded', all ? 'true' : 'false');
        btn.textContent = all ? less : moreLabel;
      });
      main.appendChild(btn);
    }
    if (ask && main) {
      var copy = ask.cloneNode(true);
      copy.classList.add('mp-faq__ask--bottom');
      main.appendChild(copy);
    }
  }
  function run(){ document.querySelectorAll('.mp-faq--split').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
